export const LOAN_STATUS = {
  PENDING: 1,
  APPROVED: 2,
  ACTIVE: 3,
  REJECTED: 4,
  CLOSED: 5,
  DELETED: 6,
  INCOMPLETE: 7,
  DISBURSAL_IN_PROGRESS: 8,
} as const;

export type LoanStatus = typeof LOAN_STATUS[keyof typeof LOAN_STATUS];

export const LOAN_STATUS_LABEL: Record<number, string> = {
  [LOAN_STATUS.PENDING]: 'Approval Pending',
  [LOAN_STATUS.APPROVED]: 'Disbursement Pending',
  [LOAN_STATUS.ACTIVE]: 'Active',
  [LOAN_STATUS.REJECTED]: 'Rejected',
  [LOAN_STATUS.CLOSED]: 'Closed',
  [LOAN_STATUS.DISBURSAL_IN_PROGRESS]: 'Disbursement in Progress',
};

export const LOAN_STATUS_COLOR: Record<
  number,
  'notice' | 'positive' | 'negative' | 'neutral' | 'information'
> = {
  [LOAN_STATUS.PENDING]: 'neutral',
  [LOAN_STATUS.APPROVED]: 'information',
  [LOAN_STATUS.ACTIVE]: 'information',
  [LOAN_STATUS.REJECTED]: 'negative',
  [LOAN_STATUS.CLOSED]: 'positive',
  [LOAN_STATUS.DISBURSAL_IN_PROGRESS]: 'information',
};

export const BADGE_TO_ICON_COLOR: Record<string, string> = {
  notice: 'feedback.icon.notice.intense',
  positive: 'feedback.icon.positive.intense',
  negative: 'feedback.icon.negative.intense',
  neutral: 'surface.icon.gray.muted',
  information: 'interactive.icon.primary.normal',
};

export const EMI_SCHEDULE_STATUS = {
  PAID: 1,
  PENDING: 2,
  SKIPPED: 3,
  PARTIAL_RECOVERY: 4,
  FULL_RECOVERY: 5,
} as const;

export const EMI_STATUS_LABEL: Record<number, string> = {
  [EMI_SCHEDULE_STATUS.PAID]: 'Paid',
  [EMI_SCHEDULE_STATUS.PENDING]: 'Pending',
  [EMI_SCHEDULE_STATUS.SKIPPED]: 'Skipped',
  [EMI_SCHEDULE_STATUS.PARTIAL_RECOVERY]: 'Partial Recovery',
  [EMI_SCHEDULE_STATUS.FULL_RECOVERY]: 'Full Recovery',
};

export const EMI_STATUS_COLOR: Record<number, 'positive' | 'notice' | 'neutral' | 'information'> = {
  [EMI_SCHEDULE_STATUS.PAID]: 'positive',
  [EMI_SCHEDULE_STATUS.PENDING]: 'notice',
  [EMI_SCHEDULE_STATUS.SKIPPED]: 'neutral',
  [EMI_SCHEDULE_STATUS.PARTIAL_RECOVERY]: 'information',
  [EMI_SCHEDULE_STATUS.FULL_RECOVERY]: 'information',
};

export const FETCH_ACTIVE_LOANS = 'FETCH_ACTIVE_LOANS';
export const FETCH_CLOSED_LOANS = 'FETCH_CLOSED_LOANS';
export const FETCH_MY_LOANS = 'FETCH_MY_LOANS';
export const FETCH_PENDING_APPROVAL_LOANS = 'FETCH_PENDING_APPROVAL_LOANS';
export const FETCH_APPROVED_LOANS = 'FETCH_APPROVED_LOANS';
export const FETCH_REJECTED_LOANS = 'FETCH_REJECTED_LOANS';
export const LOAN_SETTINGS_KEY = 'LOAN_SETTINGS';
export const LOAN_DETAIL_KEY = 'LOAN_DETAIL';
export const RECOVERY_PREVIEW_KEY = 'RECOVERY_PREVIEW';
export const EMPLOYEE_LOAN_CATEGORIES_KEY = 'EMPLOYEE_LOAN_CATEGORIES';

export const FILTER_STATUS_MAP: Record<string, number | number[] | null> = {
  all: null,
  pending: [LOAN_STATUS.PENDING, LOAN_STATUS.APPROVED],
  active: LOAN_STATUS.ACTIVE,
  closed: [LOAN_STATUS.REJECTED, LOAN_STATUS.CLOSED],
};

export const STATUS_TO_FILTER_MAP: Record<number, string> = {
  [LOAN_STATUS.PENDING]: 'pending',
  [LOAN_STATUS.APPROVED]: 'pending',
  [LOAN_STATUS.ACTIVE]: 'active',
  [LOAN_STATUS.REJECTED]: 'closed',
  [LOAN_STATUS.CLOSED]: 'closed',
};
